module.exports = __webpack_public_path__ + "static/media/logo_en.a7b47192.svg";